var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import Tooltip from '../tooltip';
import { OptionsPropType } from '../../common/box-proptypes';

import Pill from './Pill';

function stopDefaultEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}

var PillSelector = function (_Component) {
    _inherits(PillSelector, _Component);

    function PillSelector() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PillSelector);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PillSelector.__proto__ || Object.getPrototypeOf(PillSelector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isFocused: false,
            selectedIndex: -1
        }, _this.getNumSelected = function () {
            var selectedOptions = _this.props.selectedOptions;

            return typeof selectedOptions.length === 'number' ? selectedOptions.length : selectedOptions.size;
        }, _this.handleClick = function () {
            _this.inputEl.focus();
        }, _this.handleFocus = function () {
            _this.setState({ isFocused: true });
        }, _this.handleBlur = function () {
            _this.setState({ isFocused: false });
        }, _this.handleKeyDown = function (event) {
            var inputValue = _this.inputEl.value;
            var numPills = _this.getNumSelected();
            var selectedIndex = _this.state.selectedIndex;


            switch (event.key) {
                case 'Backspace':
                    {
                        var index = -1;
                        if (selectedIndex >= 0) {
                            // remove selected pill
                            index = selectedIndex;
                            _this.resetSelectedIndex();
                            _this.inputEl.focus();
                        } else if (inputValue === '') {
                            // remove last pill
                            index = numPills - 1;
                        }
                        if (index >= 0) {
                            var _this$props = _this.props,
                                onRemove = _this$props.onRemove,
                                selectedOptions = _this$props.selectedOptions;

                            var selectedOption = typeof selectedOptions.get === 'function' ? selectedOptions.get(index) : selectedOptions[index];
                            onRemove(selectedOption, index);
                            stopDefaultEvent(event);
                        }
                        break;
                    }
                case 'ArrowLeft':
                    if (selectedIndex >= 0) {
                        // select previous pill
                        _this.setState({
                            selectedIndex: Math.max(selectedIndex - 1, 0)
                        });
                        stopDefaultEvent(event);
                    } else if (inputValue === '' && numPills > 0) {
                        // select last pill
                        _this.hiddenEl.focus();
                        _this.setState({ selectedIndex: numPills - 1 });
                        stopDefaultEvent(event);
                    }
                    break;
                case 'ArrowRight':
                    {
                        if (selectedIndex >= 0) {
                            var _index = selectedIndex + 1;
                            if (_index >= numPills) {
                                // deselect last pill
                                _this.resetSelectedIndex();
                                _this.inputEl.focus();
                            } else {
                                // select next pill
                                _this.setState({ selectedIndex: _index });
                            }
                            stopDefaultEvent(event);
                        }
                        break;
                    }
                // no default
            }
        }, _this.hiddenRef = function (hiddenEl) {
            _this.hiddenEl = hiddenEl;
        }, _this.resetSelectedIndex = function () {
            if (_this.state.selectedIndex !== -1) {
                _this.setState({ selectedIndex: -1 });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PillSelector, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                isFocused = _state.isFocused,
                selectedIndex = _state.selectedIndex;

            var _props = this.props,
                className = _props.className,
                disabled = _props.disabled,
                error = _props.error,
                inputProps = _props.inputProps,
                onInput = _props.onInput,
                onRemove = _props.onRemove,
                placeholder = _props.placeholder,
                selectedOptions = _props.selectedOptions,
                rest = _objectWithoutProperties(_props, ['className', 'disabled', 'error', 'inputProps', 'onInput', 'onRemove', 'placeholder', 'selectedOptions']);

            var classes = classNames('pill-selector-input-wrapper', {
                'is-disabled': disabled,
                'is-focused': isFocused,
                'show-error': !!error
            });

            return React.createElement(
                Tooltip,
                {
                    isShown: !!error,
                    text: error,
                    position: 'middle-right',
                    theme: 'error'
                },
                React.createElement(
                    'span',
                    {
                        className: classes,
                        onBlur: this.handleBlur,
                        onClick: this.handleClick,
                        onFocus: this.handleFocus,
                        onKeyDown: this.handleKeyDown
                    },
                    selectedOptions.map(function (option, index) {
                        return React.createElement(Pill, {
                            isSelected: index === selectedIndex,
                            key: option.value,
                            onRemove: onRemove.bind(_this2, option, index),
                            text: option.text
                        });
                    }),
                    React.createElement('span', {
                        'aria-hidden': 'true',
                        className: 'accessibility-hidden',
                        onBlur: this.resetSelectedIndex,
                        ref: this.hiddenRef,
                        tabIndex: -1
                    }),
                    React.createElement('input', _extends({}, rest, inputProps, {
                        autoComplete: 'off',
                        className: classNames('pill-selector-input', className),
                        disabled: disabled,
                        onInput: onInput,
                        placeholder: this.getNumSelected() === 0 ? placeholder : '',
                        ref: function ref(input) {
                            _this2.inputEl = input;
                        },
                        type: 'text'
                    }))
                )
            );
        }
    }]);

    return PillSelector;
}(Component);

PillSelector.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.node,
    inputProps: PropTypes.object.isRequired,
    onInput: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    selectedOptions: OptionsPropType
};
PillSelector.defaultProps = {
    disabled: false,
    error: '',
    inputProps: {},
    placeholder: '',
    selectedOptions: []
};


export default PillSelector;